import { Suspense } from 'react';
import { Skeleton } from '@sara/ui/components/skeleton';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { getGetRubricQueryOptions } from '@sara/api-client';
import { RubricDetail } from '../../components/RubricDetail/RubricDetail';
import { toSuspense } from '../../../../lib/query';
import { useOrgSlug } from '../../../auth';

interface RubricDetailContainerProps {
  rubricId: string;
}

function RubricDetailSkeleton() {
  return (
    <div className="space-y-6">
      <Skeleton className="h-10 w-64" />
      <Skeleton className="h-[200px] rounded-lg" />
      <Skeleton className="h-[200px] rounded-lg" />
    </div>
  );
}

function RubricDetailContainerContent({ rubricId }: RubricDetailContainerProps) {
  const { data } = useSuspenseQuery(toSuspense(getGetRubricQueryOptions(rubricId)));
  const navigate = useNavigate();
  const orgSlug = useOrgSlug();

  return (
    <RubricDetail
      rubric={data}
      onCreateVersion={() =>
        navigate({
          to: '/orgs/$orgSlug/rubrics/$rubricId/edit',
          params: { orgSlug, rubricId },
        })
      }
    />
  );
}

export function RubricDetailContainer({ rubricId }: RubricDetailContainerProps) {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<RubricDetailSkeleton />}>
        <RubricDetailContainerContent rubricId={rubricId} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
